import React from "react";
import { IoClose } from "react-icons/io5";
import { formatCurrency } from "../../../../utility/formatCurrency";
import { useTranslation } from "react-i18next";

const ViewWorkOrderDetailsModal = ({ isOpen, onClose, workOrder }) => {
    const {t}=useTranslation();

    if (!isOpen || !workOrder) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '950px', maxWidth: '95%' }}>
                {/* Modal Header */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t("pageTitles.workOrderDetails")}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    
                    {/* Section 1: Tender Information */}
                    <fieldset className="border p-4 rounded-md mb-6 mx-4">
                        <legend className="text-sm font-bold px-2">{t("forms.workOrder.tenderInfo")}</legend>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 px-2 text-sm">
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.tenderId")} :</label>
                                <span className="font-semibold">{workOrder.tenderId}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.tenderDate")} :</label>
                                <span className="text-gray-700">{workOrder.tenderDate || "N/A"}</span>
                            </div>
                            <div className="flex gap-4 md:col-span-2">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.workTitle")} :</label>
                                <span className="text-gray-700">{workOrder.workTitle}</span>
                            </div>
                        </div>
                    </fieldset>

                    {/* Section 2: Contractor Information */}
                    <fieldset className="border p-4 rounded-md mb-6 mx-4">
                        <legend className="text-sm font-bold px-2">{t("forms.workOrder.contractorInfo")}</legend>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 px-2 text-sm">
                            <div className="flex gap-4 md:col-span-2">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.bidderName")} :</label>
                                <span className="text-gray-800">{workOrder.bidderName}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.bidDate")} :</label>
                                <span className="font-bold">₹ {formatCurrency(workOrder.bidAmount)}</span>
                            </div>
                        </div>
                    </fieldset>

                    {/* Section 3: Execution Timeline */}
                    <fieldset className="border p-4 rounded-md mb-4 mx-4 bg-blue-50/20 border-blue-100">
                        <legend className="text-sm font-bold px-2">{t("forms.workOrder.orderAndTimeline")}</legend>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 px-2 text-sm">
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.orderNo")} :</label>
                                <span className="text-gray-900 font-bold">{workOrder.workOrderNo}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.orderDate")} :</label>
                                <span className="text-gray-700">{workOrder.workOrderDate}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.startDate")} :</label>
                                <span className="text-gray-700">{workOrder.workStartDate}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.endDate")} :</label>
                                <span className="text-gray-700">{workOrder.workEndDate}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.duration")} :</label>
                                <span className="font-bold">{workOrder.duration} Days</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px' }}>{t("forms.workOrder.status")} :</label>
                                <span className={`font-bold ${workOrder.isCompleted ? 'text-green-600' : 'text-yellow-500'}`}>
                                    {workOrder.isCompleted ? 'Completed' : 'In Progress'}
                                </span>
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div className="staff-form-footer">
                    <button className="staff-btn-save px-12" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewWorkOrderDetailsModal;